goog.provide('el8.appchart.letters.faxGuide');

goog.require('el8.service.urls');
goog.require('el8.template.appchart.letters.ftue');
goog.require('el8.tourguide.Guide');
goog.require('el8.tourguide.InfoBox');
goog.require('el8.tourguide.Slide');
goog.require('el8.util.consts');


/**
 * A tourguide/FTUE teaching the user how to fax letters
 */
el8.appchart.letters.faxGuide = (function() {

    var container;

    var guide = new el8.tourguide.Guide({
        startFn: function() {
            container = $('.third-pane-content', $('#third-pane-container'));
            guide.jumpTo(0);
        }
    });

    /*
     * Step 1 of 3
     */
    var attachmentBubble = new el8.tourguide.InfoBox();
    var searchPromptBubble = new el8.tourguide.InfoBox();

    var searchPromptSlide = new el8.tourguide.Slide({
        name: 'searchPrompt',
        appendElt: container,
        showFn: function() {
            var form = el8.appchart.letters.main.getForm();
            var $toField = form.getInputField('toField');
            form.getClickItem('toField').hideMindreader();

            if ( $toField.length ) {
                searchPromptBubble.show({
                    styleClass: "el8FTUEBox",
                    contentFn: el8.template.appchart.letters.ftue.searchPrompt,
                    parentContainer: container,
                    height: 100,
                    width: 300,
                    left: $toField.offset().left - container.offset().left,
                    top:
                        $toField.offset().top -
                        container.offset().top +
                        $toField.parent().outerHeight(true),
                });
            }

            var $firstAttachment = $('.attachment-item', container).first();
            if ( $firstAttachment.length ) {
                attachmentBubble.show({
                    styleClass: "el8FTUEBox",
                    contentFn:
                        el8.template.appchart.letters.ftue.attachmentSection,
                    height: 180,
                    width: 200,
                    left: $firstAttachment.offset().left - 200,
                    top: $firstAttachment.offset().top,
                });
            }


            $.el8_setTimeout(function() {
                attachmentBubble.hide();
            }, 20*1000); // show for 20 secs
        },
        hideFn: function() {
            searchPromptBubble.hide();
            attachmentBubble.hide();
        },
        eventToSlideNameMap: {
            'letter-chose-contact': 'editContact',
            'letter-wrote-name': 'addDetails',
            'letter-no-results': 'blurField',
            'raw-fax-show': 'rawFax'
        }
    });
    guide.addSlide(searchPromptSlide);

    /*
     * Step 2 options
     */
    var editContactBubble = new el8.tourguide.InfoBox();
    var editContactSlide = new el8.tourguide.Slide({
        name: 'editContact',
        appendElt: container,
        showFn: function() {
            var $editTrigger = $('.edit-trigger', container);
            var topOffset = $editTrigger.offset().top - container.offset().top +
                ($editTrigger.closest('.to-field-input').outerHeight(true) || 0) / 2;
            editContactBubble.show({
                styleClass: 'el8FTUEBox',
                contentFn: el8.template.appchart.letters.ftue.editContact,
                parentContainer: container,
                height: 100,
                width: 300,
                left: $editTrigger.offset().left - container.offset().left - 250,
                top: topOffset
            });
            editContactBubble.getContainer().on('click', '.jump-to-end',  function() {
                guide.jumpToName('send');
            });
        },
        hideFn: function() {
            editContactBubble.getContainer().off('click', '.jump-to-end');
            editContactBubble.hide();
        },
        eventToSlideNameMap: {
            'letter-no-results': 'blurField',
            'letter-wrote-name': 'addDetails',
            'raw-fax-show': 'rawFax',
            'hide-unmapped-profile': 'send'
        }
    });
    guide.addSlide(editContactSlide);

    var addDetailsBubble = new el8.tourguide.InfoBox();
    var addDetailsSlide = new el8.tourguide.Slide({
        name: 'addDetails',
        appendElt: container,
        showFn: function() {
            var $editTrigger = $('.edit-trigger', container);
            var topOffset = $editTrigger.offset().top - container.offset().top +
                $editTrigger.closest('.to-field-input').outerHeight(true) / 2;

            addDetailsBubble.show({
                styleClass: 'el8FTUEBox',
                contentFn: el8.template.appchart.letters.ftue.addDetails,
                parentContainer: container,
                height: 100,
                width: 310,
                left: $editTrigger.offset().left - container.offset().left - 250,
                top: topOffset
            });
        },
        hideFn: function() {
            addDetailsBubble.hide();
        },
        eventToSlideNameMap: {
            'letter-chose-contact': 'editContact',
            'letter-no-results': 'blurField',
            'hide-unmapped-profile': 'send'
        }
    });
    guide.addSlide(addDetailsSlide);

    var blurFieldBubble = new el8.tourguide.InfoBox();
    var blurFieldSlide = new el8.tourguide.Slide({
        name: 'blurField',
        appendElt: container,
        showFn: function() {
            var form = el8.appchart.letters.main.getForm();
            var $toField = form.getInputField('toField');
            var topOffset = $toField.offset().top - container.offset().top +
                ($toField.parent().outerHeight(true) || 0) + 40;

            blurFieldBubble.show({
                styleClass: 'el8FTUEBox',
                contentFn: el8.template.appchart.letters.ftue.blurField,
                parentContainer: container,
                height: 45,
                width: 330,
                left: $toField.offset().left - container.offset().left,
                top: topOffset
            });
        },
        hideFn: function() {
            blurFieldBubble.hide();
        },
        eventToSlideNameMap: {
            'letter-chose-contact': 'editContact',
            'letter-wrote-name': 'addDetails',
            'raw-fax-show': 'rawFax'
        }
    });
    guide.addSlide(blurFieldSlide);

    // just a location holder, since the nag bubble will be visible
    var rawFaxSlide = new el8.tourguide.Slide({
        name: 'rawFax',
        appendElt: container,
        eventToSlideNameMap: {
            'letter-chose-contact': 'editContact',
            'letter-wrote-name': 'addDetails',
            'letter-no-results': 'blurField',
            'raw-fax-hide': 'send'
        }
    });
    guide.addSlide(rawFaxSlide);

    /*
     * Step 3
     */
    var sendBubble = new el8.tourguide.InfoBox();
    var sendSlide = new el8.tourguide.Slide({
        name: 'send',
        appendElt: container,
        showFn: function() {
            var $letterButtons = $('#letter-buttons');
            sendBubble.show({
                styleClass: 'el8FTUEBox',
                contentFn: el8.template.appchart.letters.ftue.send,
                height: 100,
                width: 300,
                left: $letterButtons.offset().left,
                top: $letterButtons.offset().top - 110
            });
            sendBubble.getContainer().on('click', '.finish-trigger',  function() {
                guide.end();
            });
        },
        hideFn: function() {
            sendBubble.getContainer().off('click', '.finish-trigger');
            sendBubble.hide();
        }
    });
    guide.addSlide(sendSlide);

    return guide;

})();